


import { EXPANDER_DEFAULT_ICON_SIZE } from './expanderIconDefaultProps';

export const DATA_TABLE_TREE_EXPANDER_ICON_SIZE = EXPANDER_DEFAULT_ICON_SIZE;